import { PlaylistDescriptor } from 'components/profile/playlists/BusinessPlaylistsDialogListsPage';
import { StoreType, useActions } from '@tock/shared/utils/connect';
import { consumer } from '@tock/coretypes';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

const useLoadPlaylists = () => {
  const { actions } = useActions();
  const { patron, isInitialized } = useSelector((state: StoreType) => ({
    patron: state.app.patron,
    isInitialized: state.patron.playlists.isInitialized,
  }));

  return useEffect(() => {
    if (patron?.id && !isInitialized) {
      actions.patron.fetchPlaylists(patron.id);
    }
  }, [patron, isInitialized, actions.patron]);
};

export default useLoadPlaylists;

export const useSharePlaylist = () => {
  const { actions } = useActions();

  return (playlist: consumer.Playlist) => {
    const url = `${window.location.origin}/playlist/${playlist.id}`;
    window.analytics.sendEvent('Playlist', 'Shared', 'Playlist public  url copied');
    if (!!navigator.share as boolean) {
      navigator.share({
        title: playlist.name,
        text: `Check out ${playlist.creator?.firstName}${
          playlist.creator?.lastName && ' ' + playlist.creator?.lastName
        }'s Tock list!`,
        url,
      });
      return;
    }
    if (navigator.clipboard) {
      navigator.clipboard.writeText(url);
      actions.toast.showInfo('Copied link');
    }
  };
};

export const useInitializePlaylistDefaults = (playlistDescriptors: PlaylistDescriptor[]) => {
  const { actions } = useActions();
  const numPlaylistRequestsInProgress = useSelector(
    (state: StoreType) => state.patron.playlists.numRequestsInProgress
  );
  const [isSendingDefaults, setIsSendingDefaults] = useState(false);
  const isInitialized = useSelector((state: StoreType) => state.patron.playlists.isInitialized);

  useEffect(() => {
    if (isInitialized && numPlaylistRequestsInProgress === 0 && !isSendingDefaults) {
      const defaultPlaylists = playlistDescriptors.filter(
        (playlistDescriptor) => playlistDescriptor.id < 0
      );

      if (defaultPlaylists.length > 0) {
        setIsSendingDefaults(true);
        initializePlaylists(defaultPlaylists, actions.patron.upsertPlaylist).finally(() =>
          setIsSendingDefaults(false)
        );
      }
    }
  }, [
    playlistDescriptors,
    isInitialized,
    actions.patron,
    numPlaylistRequestsInProgress,
    isSendingDefaults,
  ]);
};

const initializePlaylists = async (
  playlists: PlaylistDescriptor[],
  upsertPlaylist: (playlist: consumer.IPlaylist) => void
) => {
  for (const defaultPlaylist of playlists) {
    await upsertPlaylist({ name: defaultPlaylist.name });
  }
};
